<dashboardnav>

  <cradua-subsubgroup
  [subsubgrouptypecategorys]="subsubgrouptypecategorys$ | async"
  [subsubgrouptypes]="subsubgrouptypes$ | async"
  [categorys]="categorys$ | async"
  [subgroups]="subgroups$ | async"
  [subsubgroups]="subsubgroups$ | async"

  (changeEmit)="onSubmitSubSubGroup($event)"
  (deleteEvent)="onDeleteSubSubGroup($event)"
  *ngIf="
  !(isLoadingSubSubGroupTypeCategory$ | async ) &&
  !(isLoadingSubSubGroupType$ | async ) &&
  !(isLoadingCategory$ | async ) &&
  !(isLoadingSubGroup$ | async ) &&
  !(isLoadingSubSubGroup$ | async )
  "
  >
  </cradua-subsubgroup>

  <mrsoftapps-epims-reference-spinner
  *ngIf="
  (isLoadingSubSubGroupTypeCategory$ | async ) ||
  (isLoadingSubSubGroupType$ | async ) ||
  (isLoadingCategory$ | async ) ||
  (isLoadingSubGroup$ | async ) ||
  (isLoadingSubSubGroup$ | async )
  "
>
  </mrsoftapps-epims-reference-spinner>
</dashboardnav>
